import { render, staticRenderFns } from "./ColumnGroup.vue?vue&type=template&id=893d4ade&"
import script from "./ColumnGroup.vue?vue&type=script&lang=js&"
export * from "./ColumnGroup.vue?vue&type=script&lang=js&"
import style0 from "./ColumnGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/oem/work/Rails/tosdere_erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('893d4ade', component.options)
    } else {
      api.reload('893d4ade', component.options)
    }
    module.hot.accept("./ColumnGroup.vue?vue&type=template&id=893d4ade&", function () {
      api.rerender('893d4ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/utils/datatable/HeaderSettings/ColumnGroup.vue"
export default component.exports